module.exports = __webpack_public_path__ + "post-listing-hero@2x-3_kDhCW.jpg";